import { Popup } from "@/components/popups/Popup";
import { CopyTextControl } from "@/components/controls/CopyTextControl";

import "./EmbedDialog.scss";
import { useCallback } from "react";
import { metricsBus } from "@/common/buses";

export const EmbedDialog = (props: {
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
  onClose: () => void;
  isOpen: boolean;
}) => {
  const { fixedEmbedCode, responsiveEmbedCode, onClose, isOpen } = props;

  const handleClickFixedEmbed = useCallback(() => {
    metricsBus.emit("sharedFixedEmbed");
  }, []);

  const handleClickResponsiveEmbed = useCallback(() => {
    metricsBus.emit("sharedResponsiveEmbed");
  }, []);

  return (
    <Popup
      onClose={onClose}
      isOpen={isOpen}
      popupClass="EmbedDialog"
      title="Embed"
    >
      <>
        <div className="group">
          <label>Fixed frame:</label>
          <CopyTextControl value={fixedEmbedCode} onClick={handleClickFixedEmbed}/>
        </div>

        <div className="group">
          <label>Responsive frame:</label>
          <CopyTextControl value={responsiveEmbedCode} onClick={handleClickResponsiveEmbed}/>
        </div>
      </>
    </Popup>
  );
};
